'use client';

import { Mic } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export default function GuideBadge() {
  return (
    <Badge variant="secondary" className="gap-1 text-xs font-medium">
      <Mic className="w-3 h-3" />
      Conversation Guide
    </Badge>
  );
}
